<template>
  <div class="cycle_run_rule" v-if="clazz">
    <div class="header between_border">
      <div class="info">
        <div class="clazz_name">{{ clazz.clazz_name }}</div>
        <div class="cycle_range">
          {{ clazz.start_time_format2 }} ~ {{ clazz.end_time_format2 }}
        </div>
      </div>
      <div class="limit">
        <div class="limit_item">
          <div class="one"><span>{{ clazz.week_num }}</span> 周</div>
          <div class="two">总周数</div>
        </div>
        <div class="limit_item">
          <div class="one"><span>{{ clazz.rule_content.distance }}</span> KM</div>
          <div class="two">总里程</div>
        </div>
      </div>
    </div>

    <van-swipe
      v-if="weekList.length"
      :initial-swipe="currWeek"
      :loop="false"
      :show-indicators="false"
      @change="changeWeek"
    >
      <van-swipe-item v-for="(week, index1) in weekList" :key="index1">
        <div class="week_list">
          <div class="day"
            v-for="(day, index2) in week"
            :key="index2"
            :class="{active: day-selectedDay===0}"
            @click="selectDay(day)"
          >
            <div class="one">{{ day | weekDayOfDate }}</div>
            <div class="two">{{ day | dayOfDate }}</div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>

    <div class="body" v-if="currRule">
      <div class="title">慢跑{{ currRule.distance }}公里</div>
      <div class="intro">描述信息描述信息描述信息描述信息</div>
    </div>
  </div>
</template>

<script>
import { Icon, Progress, Swipe, SwipeItem } from 'vant'
import ClazzHeader from '../ClazzHeader'
import { todayDate, getCycleWeekDay } from '@/utils/index'

export default {
  name: 'CycleRunRule',
  components: {
    [Icon.name]: Icon,
    [Progress.name]: Progress,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    ClazzHeader
  },
  props: {
    clazz: {
      type: Object,
      default () {
        return null
      }
    }
  },
  data () {
    return {
      currWeek: 0,
      currRule: null,
      selectedDay: null,
      weekList: [],
      stat: null
    }
  },
  filters: {
    weekDayOfDate (value) {
      const weekMap = ['日', '一', '二', '三', '四', '五', '六']
      const week = value.getDay()
      return weekMap[week]
    },
    dayOfDate (value) {
      return value.getDate()
    }
  },
  created () {
    this.getCycleWeekDay()
  },
  methods: {
    async getCycleWeekDay () {
      this.currWeek = this.clazz.past_week_num
      this.weekList = getCycleWeekDay(this.clazz.start_time_format2, this.clazz.week_num)

      this.initSelectedDay()
    },
    initSelectedDay () {
      const today = todayDate()
      const startDay = this.weekList[this.currWeek][0]
      const lastIdx = this.weekList.length - 1
      const endDay = this.weekList[lastIdx][6]
      if (today < startDay) {
        this.selectDay(startDay)
      } else if (today > endDay) {
        this.selectDay(endDay)
      } else {
        this.selectDay(today)
      }
    },
    selectDay (day) {
      this.selectedDay = day

      const weekMap = ['sun', 'mon', 'tues', 'wed', 'thur', 'fri', 'sat']
      const week = day.getDay()
      const weekLabel = weekMap[week]

      this.currRule = this.clazz.rule_content.ruleList[this.currWeek][weekLabel]
    },
    changeWeek (index) {
      this.currWeek = index
    }
  }
}
</script>

<style scoped lang="scss">
.cycle_run_rule {
  .header {
    background-color: #343344;
    // background-color: #333a46;
    // background-color: #282c34;
    padding: 30px 30px;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info {
      .clazz_name {
        font-size: 30px;
        margin-bottom: 5px;
      }
      .cycle_range {
        color: #969696;
        font-size: 28px;
      }
    }
    .limit {
      font-size: 26px;
      display: flex;
      text-align: center;
      .limit_item {
        margin-left: 30px;
        font-size: 26px;
        .one {
          margin-bottom: 5px;
          span {
            font-size: 36px;
          }
        }
        .two {
          color: #969696;
          font-size: 24px;
        }
      }
    }
  }
  .week_list {
    background-color: #343344;
    color: #c4c1c1;
    height: 150px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .day {
      width: 80px;
      font-size: 30px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .one {
        font-size: 28px;
      }
      .two {
        margin-top: 8px;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      &.active {
        .two {
          color: #fff;
          background-color: #333;
        }
      }
    }
  }
  .body {
    .title {
      margin-top: 100px;
      text-align: center;
      font-size: 32px;
    }
    .intro {
      padding: 0 30px;
      margin-top: 100px;
      font-size: 28px;
    }
  }
}
</style>
